// extracted by mini-css-extract-plugin
export default {"body":"BurgerMenu_body__APhxr","isShown":"BurgerMenu_isShown__MdMsC","burgerLine":"BurgerMenu_burgerLine__EFdjG"};